import { useState, useEffect, useRef } from "react"
import { buildEmptyPortfolio } from "~utils/portfolio"
import { Holdings } from "~shapes/portfolio"

export const usePortfolioData = (
  fetcherHook: any,
  userId: string,
  extractPortfolioData: (rawData: any, selectedBroker?: string) => any | null,
  selectedBroker?: string,
  securities?: any[],
) => {
  const [portfolio, setPortfolio] = useState<Holdings[]>([])
  const [existPortfolio, setExistPortfolio] = useState(false)
  const [brokerName, setBrokerName] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [selectedPortfolio, setSelectedPortfolio] = useState<any>(null)
  const isMountedRef = useRef(true)

  const filter = async (rawData: any) => {
    if (!isMountedRef.current) return

    setIsLoading(true)
    const portfolioData = extractPortfolioData(rawData, selectedBroker)
    if (!portfolioData) {
      const empty = await buildEmptyPortfolio(securities)
      if (!isMountedRef.current) return

      setPortfolio(empty)
      setExistPortfolio(false)
      setBrokerName("")
      setSelectedPortfolio(null)
      setIsLoading(false)
      return
    }

    if (!isMountedRef.current) return

    setExistPortfolio(true)
    setSelectedPortfolio(portfolioData)

    const empty = await buildEmptyPortfolio(securities)
    if (!isMountedRef.current) return

    portfolioData.holdings?.forEach((holding: Holdings) => {
      const index = empty.findIndex(
        item => item.security.code === holding.security.code,
      )
      if (index !== -1) {
        empty[index].quantity += holding.quantity
      }
    })

    if (!isMountedRef.current) return

    setPortfolio(empty)
    setIsLoading(false)
  }

  const { data, refetch, isFetching, isError } = fetcherHook(userId, filter)

  useEffect(() => {
    if (data) {
      filter(data).then()
    }
  }, [data, selectedBroker])

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  return {
    portfolio,
    selectedPortfolio,
    brokerName,
    isLoading: isLoading || isFetching,
    existPortfolio,
    isError,
    refetch,
    rawPortfolios: data,
  }
}
